import React from 'react';
import AuthLayout from 'layouts/AuthLayout';
import {Link} from "react-router-dom";

const ResetPasswordThankYouPage = () => {
    return (
        <AuthLayout>
            <div className="reset-password-thankyou-page">
                <h5>Password successfully changed.</h5>
                <Link to="/auth/login">Login</Link>
            </div>
        </AuthLayout>
    )
}

export default ResetPasswordThankYouPage;